export enum FormSelectMessages {
  LOADING = 'Loading...',
  NO_RESULTS = 'No results found',
}
